import Plyr from "plyr";
import "plyr/dist/plyr.css";

/**
 * Plyr動画プレイヤーの初期化
 * カスタムスタイルで可愛いプレイヤーを実装
 */
export const initPlyr = () => {
  const player = document.querySelector(".js-plyr");

  if (!player) return;

  // Plyrの初期化
  const plyrInstance = new Plyr(player, {
    controls: [
      "play-large", // 中央の大きな再生ボタン
      "play", // 再生/一時停止ボタン
      "progress", // プログレスバー
      "current-time", // 現在の再生時間
      "duration", // 動画の長さ
      "mute", // ミュートボタン
      "volume", // ボリュームコントロール
      "settings", // 設定メニュー
      "fullscreen", // フルスクリーンボタン
    ],
    settings: ["quality", "speed"],
    speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 2] },
    quality: {
      default: 1080,
      options: [1080, 720, 480],
    },
    i18n: {
      // 日本語化
      restart: "最初から",
      rewind: "{seektime}秒戻る",
      play: "再生",
      pause: "一時停止",
      fastForward: "{seektime}秒進む",
      seek: "シーク",
      seekLabel: "{currentTime} / {duration}",
      played: "再生済み",
      buffered: "バッファ済み",
      currentTime: "現在の時間",
      duration: "長さ",
      volume: "音量",
      mute: "ミュート",
      unmute: "ミュート解除",
      enableCaptions: "字幕を表示",
      disableCaptions: "字幕を非表示",
      download: "ダウンロード",
      enterFullscreen: "フルスクリーン",
      exitFullscreen: "フルスクリーン終了",
      frameTitle: "{title}の動画プレイヤー",
      captions: "字幕",
      settings: "設定",
      menuBack: "前のメニューに戻る",
      speed: "再生速度",
      normal: "標準",
      quality: "画質",
      loop: "ループ",
    },
  });

  // セッションストレージとの連携（既存の機能を維持）
  plyrInstance.on("ended", () => {
    sessionStorage.setItem("simba-video-played", "true");
    document.body.classList.add("video-played");
  });

  return plyrInstance;
};
